import { combineReducers } from "redux";
import UserReducer from "./UserReducer";
import GamesDataReducer from "./GamesDataReducer";
import CartReducer from "./CartReducer";

const rootReducer = combineReducers({
  UserReducer,
  GamesDataReducer,
  CartReducer,
});

export default rootReducer;
